// extracted by mini-css-extract-plugin
module.exports = {"center":"center_center__kG00p","intrinsic":"center_intrinsic___pihD"};